import { gameService } from '../gameService';

import { parseQuery } from '../../core/helpers/parseQuery';
import { socketGamePath } from '../../core/constants/gameConfigsAndUrls';
import { environmentBuilder } from '../../core/helpers/environmentBuilder';
import { GameLiveConnection } from '../../core/classes/gameLiveConnection';
import { DefaultQueryParams } from '../../core/constants/defaultQueryParams';
import { GameLiveConnectionMethod } from '../../core/constants/connectionTypes';

import { applicationStore } from '../../store/applicationStore';

class GameConnection extends GameLiveConnection {
  constructor(url) {
    super(url);
  }

  async sendGameGetInitialState(isFirst = true) {
    if (isFirst) {
      this.executeConnections();
    }
    await this.sendInitial();
  }

  async sendInitial() {
    const {
      [DefaultQueryParams.PartnerId]: partnerId,
      [DefaultQueryParams.GameId]: gameId,
      [DefaultQueryParams.TournamentId]: tournamentid,
    } = parseQuery(window.location.search);

    await super.sendGetInitialState({ partnerId, gameId, tournamentid });
  }

  handleInitialResult(data) {
    if (!data) {
      const { [DefaultQueryParams.PartnerId]: partnerId, [DefaultQueryParams.GameId]: gameId } =
        parseQuery(window.location.search);
      setTimeout(() => {
        super.sendGetInitialState({ partnerId, gameId }).then(() => {});
      }, 500);
    } else {
      gameService.onGetInitialStateResult.call(gameService, data);
    }
  }

  Spin(model) {
    super.on('Spin', model);
  }

  SpinResult(resultData) {
    super.on('SpinResult', resultData);
  }

  sendPing() {
    super.invoke('Ping');
  }

  getPong() {}

  getBalance() {
    return super.invoke(GameLiveConnectionMethod.GetBalance);
  }

  getTournamentBalance(...params) {
    return super.invoke(GameLiveConnectionMethod.GetTournamentBalance, ...params);
  }

  sendGamble(model) {
    applicationStore.isDemo ? this.demoGamble(model) : this.gamble(model);
  }

  doSpinCollect(model) {
    applicationStore.isDemo ? this.demoSpinCollect(model) : this.spinCollect(model);
  }

  doSpin(spinModel) {
    applicationStore.isDemo ? this.demoSpin(spinModel) : this.spin(spinModel);
  }

  doBonusSpin(spinModel) {
    applicationStore.isDemo ? this.demoBonusSpin(spinModel) : this.bonusSpin(spinModel);
  }

  executeConnections() {
    super.onGetInitialStateResult(this.handleInitialResult.bind(this));

    // Spin
    super.onSpinResult(gameService.handleSpinResult.bind(gameService));
    super.onDemoSpinResult(gameService.handleSpinResult.bind(gameService));

    // Game Free spin
    super.onDemoBonusSpinResult(gameService.handleSpinResult.bind(gameService));
    super.onBonusSpinResult(gameService.handleSpinResult.bind(gameService));

    // Free bet
    super.onFreeBetAwarded(gameService.handleFreeBetAwarded.bind(gameService));

    // Jackpot
    super.onJackpotSceneResult(gameService.handleJackpotSceneResult.bind(gameService));
    super.onJackpotSceneItemResult(gameService.handleJackpotSceneItemResult.bind(gameService));

    // BoostedJackpot
    super.onGetBoostedJackpotWinResult(gameService.handleBoostedJackpotWinResult.bind(gameService));

    // Gamble
    super.onGambleResult(gameService.handleGambleResult.bind(gameService));
    super.onDemoGambleResult(gameService.handleGambleResult.bind(gameService));
    super.onSpinCollectResult(gameService.handleSpinCollectResult.bind(gameService));
    super.onDemoSpinCollectResult(gameService.handleSpinCollectResult.bind(gameService));

    // Tournament
    super.onTournamentInfoResult(gameService.handleTournamentInfoResult.bind(gameService));

    // Core events
    super.onPing(this.getPong);
    super.onClose();
    super.onGameOpen();
    super.onReconnected();
    super.onReconnecting();
    super.onBalanceUpdate();
    super.onTournamentBalanceUpdate();
    super.onMaintenanceNotify();
  }
}

const { socketUrl } = environmentBuilder();

const url = (path) => ({ url: `${socketUrl}${path}` });

export const gameLiveConnection = new GameConnection(url(socketGamePath));
